import { render, staticRenderFns } from "./visp-task-service.vue?vue&type=template&id=d455aa60&"
import script from "./visp-task-service.vue?vue&type=script&lang=js&"
export * from "./visp-task-service.vue?vue&type=script&lang=js&"
import style0 from "./visp-task-service.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports